import script from "./CompetitionStandingsTeam.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompetitionStandingsTeam.vue?vue&type=script&lang=ts&setup=true"

import "./CompetitionStandingsTeam.vue?vue&type=style&index=0&id=6ed61b19&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed61b19"]])

export default __exports__